import styled from '@emotion/styled';

export const LabelWrapper = styled.div`
    padding-bottom: 5px;
`;
